import printComponent from './final_residual_count_commit_print.component';

let printFinalResidualCountCommitModule = angular.module('printFinalResidualCountCommit', [
])
    .config(($stateProvider, $urlRouterProvider) => {
        "ngInject";

        $urlRouterProvider.otherwise('/branchManagement.locations');

        $stateProvider
            .state('printFinalResidualCountCommit', {
                url: '/print-final-residual-count-commit',
                component: 'printFinalResidualCountCommit',
                data: {
                    requireLogin: true,
                    requireACL: 'branch_mgmt_final_residual_count_commit.all'
                },
            })
    })

    .component('printFinalResidualCountCommit', printComponent)

    .name;

export default printFinalResidualCountCommitModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/final_residual_count_commit/print/index.js